import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/utils/Stream';
import LoadingIndicator from "flarum/components/LoadingIndicator";

import UserSubmitModal from "./modal/UserSubmitModal";
import InfoSubmitModal from "./modal/InfoSubmitModal";
import InfoUserType9ListItem from "./InfoUserType9ListItem";

export default class InfoSidebarUserType9Component extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.viewType = this.attrs.viewType;
    this.loading = true;
    this.moreResults = false;
    this.u2diInfoList = [];
    this.wrapData = {initType:"add",from:"infoImport"};

    this.loading = true;
    this.listFilters = Stream("-1");
    this.listSort = Stream("desc");
    this.loadResult();

    const _this = this;

    $(window).off("u2diInfoAdd").on("u2diInfoAdd",function(e){
      _this.filterItem(e);
    })
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }

  view() {
    const u2diInfoList = this.u2diInfoList;
    const wrapData = this.wrapData;

    let counter = 0;
    let loading;

    if (this.loading) {
      loading = LoadingIndicator.component({ size: "large" });
    }

    return (
      <div>
        {this.viewType==="normal" && (
          <div className="u2diMapSideBarTitleContainier">
          
            <div className="u2diMapSideBarTitle">{app.translator.trans("ziven-u2di.forum.map-sidebar-land-title-admin")}</div>

            <div className="u2diMapSideBarMagageArea u2diInfoItemContainer">
              <div style="width:100px;position: relative;">
                <Select className="u2diDataSelectList" value={this.listFilters()}
                  style = "width:195px"
                  disabled={this.loading}
                  options={{
                    "-1":app.translator.trans("ziven-u2di.forum.map-info-filter-all"),
                    "0":app.translator.trans("ziven-u2di.forum.map-info-filter-wqy"),
                    "1":app.translator.trans("ziven-u2di.forum.map-info-filter-wqy-mark"),
                    "2":app.translator.trans("ziven-u2di.forum.map-info-filter-wtg"),
                    "3":app.translator.trans("ziven-u2di.forum.map-info-filter-wcj"),
                    "4":app.translator.trans("ziven-u2di.forum.map-info-filter-ycj"),
                    "5":app.translator.trans("ziven-u2di.forum.map-info-filter-ysx"),
                    "6":app.translator.trans("ziven-u2di.forum.map-info-filter-bc"),
                    "7":app.translator.trans("ziven-u2di.forum.map-info-filter-qbtd"),
                    "8":app.translator.trans("ziven-u2di.forum.map-info-filter-qbjz"),
                    "9":app.translator.trans("ziven-u2di.forum.map-info-filter-dz"),
                    "10":app.translator.trans("ziven-u2di.forum.map-info-filter-yk"),
                  }}
                  onchange={(e) => { 
                    this.listFilters(e); 
                    this.filterItem(e)
                  }}
                />

                <div style="right: -105px;" className="u2diDataSort" onclick={(e) => { this.sortItem(e) }}>
                  <i style={this.listSort()==="asc"?"color:var(--primary-color)":""} class="fas fa-sort-up"></i>
                  <i style={this.listSort()==="desc"?"color:var(--primary-color)":""} class="fas fa-sort-down"></i>
                </div>
              </div>

              <div>
                {Button.component({
                    style:'font-size: 12px;font-weight: normal;padding: 8px;',
                    disabled:this.loading,
                    className: 'Button Button--primary',
                    onclick: () => {
                      app.modal.show(InfoSubmitModal,{wrapData});
                    }
                  },
                  app.translator.trans('ziven-u2di.forum.button-import-deal')
                )}
              </div>
            </div>

            <div style="height: calc(100vh - 340px)" className="u2diMapSideBarContentContainier">
              {u2diInfoList.map((infoBaseData) => {
                return (
                  <div id={"u2diInfo"+infoBaseData.id()} style="padding-top: 15px;">
                    {InfoUserType9ListItem.component({ infoBaseData })}
                  </div>
                );
              })}

              {!this.loading && u2diInfoList.length===0 && (
                <div>
                  <div style="font-size:1.4em;color: var(--muted-more-color);text-align: center;height: 300px;line-height: 100px;">{app.translator.trans("ziven-u2di.lib.list-empty")}</div>
                </div>
              )}

              {!loading && this.hasMoreResults() && (
                <div className="u2di-loadMore" style="text-align:center;padding:20px">
                  <Button className={'Button Button--primary'} disabled={this.loading} loading={this.loading} onclick={() => this.loadMore()}>
                    {app.translator.trans('ziven-u2di.lib.load-more')}
                  </Button>
                </div>
              )}

              {loading && <div className="u2di-loadMore">{loading}</div>}
            </div>
          </div>
        )}

      </div>
    );
  }

  sortItem(e){
    const listSort = this.listSort();

    if(listSort==="desc"){
      this.listSort("asc");
    }else if(listSort==="asc"){
      this.listSort("desc");
    }

    this.u2diInfoList = [];
    this.loading = true;
    m.redraw();
    this.loadResult();
  }

  filterItem(e){
    this.u2diInfoList = [];
    this.loading = true;
    m.redraw();
    this.loadResult();
  }

  parseResults(results) {
    this.moreResults = !!results.payload.links && !!results.payload.links.next;
    [].push.apply(this.u2diInfoList, results);
    this.loading = false;
    m.redraw();

    return results;
  }

  loadMore() {
    this.loading = true;
    this.loadResult(this.u2diInfoList.length);
  }

  hasMoreResults() {
    return this.moreResults;
  }

  loadResult(offset = 0){
    const listFilters = parseInt(this.listFilters());
    const listSort = this.listSort();
    const filters = {};

    switch(listFilters){
      case 0: filters["signed"] = 0; break;
      case 1: filters["signed_mark"] = 0; break;
      case 2: filters["promoted"] = 0; break;
      case 3: filters["status"] = 0; break;
      case 4: filters["status"] = 1; break;
      case 5: filters["status"] = 2; break;
      case 6: filters["reports"] = 1; break;
      case 7: filters["category"] = "tdwz"; break;
      case 8: filters["category"] = "jzwz"; break;
      case 9: filters["userType"] = -1; break;
      case 10: filters["userType"] = 0; break;
    }

    if(listSort!==""){
      filters["sort"] = listSort
    }

    app.store
      .find("u2diInfoList/a", {
      filter:filters,
      page: {
        offset,
      },
    })
    .catch(() => {})
    .then(this.parseResults.bind(this));
  }

}